import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["topTickersContainer"];

  connect() {
    const observer = new IntersectionObserver( (changes)=> {
      for (const change of changes) {
        if (this.triggeredTopTickersLoad === true){
          return
        }
        if (change.isIntersecting === false) {
          return
        }
        this.triggeredTopTickersLoad = true
        this.fetchAndLoadTopTickers(); 
      }
    });
    observer.observe(this.topTickersContainerTarget)
  }

  fetchAndLoadTopTickers = () => {
    fetch(this.topTickersContainerTarget.getAttribute("data-url"))
      .then(response => {
        return response.text();
      }).then( html => {
        this.topTickersContainerTarget.innerHTML = html;
      }).then( () => {
        document.dispatchEvent(new CustomEvent('currency-selector-loaded'));
      })
  }
}
